export const parseSearchParams = (paramName) => {
	return new URL(window.location.href).searchParams.get(paramName);
};
